/**
 * @file register.service.ts
 * @author Codeforce
 * @date 23 Mar 2020
 * @copyright 2020 Bisnode Deutschland GmbH
 * @brief Communication with Backend/Orchestrator
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateList} from '../../models/translatelist';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class RegisterService {
  /**
   * Variables that are needed for the service
   */
  url: string = '';
  language = '';

  /**
   *  We pass the constructor the apiEndPoint(Backend URL)
   */
  constructor(private http: HttpClient) {
    this.url = environment.apiEndPoint;
  }

  /**
   * @brief function subscribe()
   * @param userData - the data from the Angular form
   * @return response: success/failure/exists in the database
   * @details function to subscribe a user and save it to the database
   * @details We post the data to the backend server (database) and enter the userData from the Angular form
   */
  public subscribe(userData) {
    return this.http.post<any>(this.url + '/subscriber', userData);
  }

  /**
   * @brief function unsubscribe()
   * @param userData - the data from the Angular form
   * @return response: success/failure
   * @details function to unsubscribe a user and save it to the database
   * @details We post the data to the backend server (database) and enter the userData from the Angular form
   */
  public unsubscribe(userData) {
    return this.http.post<any>(this.url + '/unsubscribe', userData);
  }

  /**
   * @brief loadTranslateDataFromDB()
   * @param language - param from subscriber.components.ts (URL)
   * @return TranslateList - list of the language labels (key, value List)
   * @details We get the label informations, that are used in frontend from the database
   */
  public loadTranslateDataFromDB(language): Observable<TranslateList[]> {
    return this.http.post<TranslateList[]>(this.url + '/translate' , {"language": language});
  }

  /**
   * @brief verifySubscriber()
   * @param token, ip - used from the confirm.components.ts
   * @return response: success/not exists
   * @details function to verify, if the token exists in the database
   */

  public verifySubscriber(token, ip): Observable<any> {
    return this.http.post<any>(this.url + '/verify' , {"token": token, "ip": ip});
  }

  /**
   * @brief getIPAddress()
   * @param -
   * @return response: success/not exists
   * @details function to get the IP Address
   */

  public getIPAddress(): Observable<any> {
    return this.http.post<any>(this.url + '/getIP' , {});
  }

  unsubscribeAll(userData) {
    console.log(userData);
    return this.http.post<any>(this.url + '/unsubscribeAll', userData);
  }
}
